import { render, staticRenderFns } from "./priority-api.vue?vue&type=template&id=af4e200e&"
import script from "./priority-api.vue?vue&type=script&lang=js&"
export * from "./priority-api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports